import IconButton from '@legacy-vfuk/core-icon-button';
import { InteractionEvent } from '@legacy-vfuk/core-interaction';
import React from 'react';

type AnimationControlButtonProps = {
  isPlaying: boolean;
  onClick: (event: InteractionEvent) => void;
};

const AnimationControlButton: React.FC<AnimationControlButtonProps> = ({
  isPlaying,
  onClick,
}) => {
  return (
    <IconButton
      srText={isPlaying ? 'pause' : 'play'}
      appearance="secondary"
      icon={{ name: isPlaying ? 'pause' : 'play-arrow' }}
      size={2}
      shape="circle"
      onClick={onClick}
    />
  );
};

export default AnimationControlButton;
